import React, { useState } from 'react'
import ContactUs from '../sections/home/Contactus'
import Banner from '../sections/home/Banner'
import PopularCategories from '../sections/home/PopularCategories'
import Events from '../sections/home/Events'
import Precision from '../sections/home/Precision'
import Blogs from '../sections/home/Blogs'
import About from '../sections/home/About'



function Home({ isAuthenticated }) {

    return (
        <div style={{backgroundColor:'black'}}>
            <Banner {...{ isAuthenticated }} />
            {!isAuthenticated && <PopularCategories />}
            <Events {...{ isAuthenticated }} />
            <Precision />
            <Blogs {...{ isAuthenticated }} />
            <About />
            <ContactUs />
        </div>
    )
}

export default Home
